import React from 'react';
import classes from './ReviewPromptModal.module.scss';
import { useAlert } from 'react-alert';
import Overlay from '../../atoms/Overlay/Overlay';
import Button from '../../atoms/Button/Button';
import Oinq from '../../assets/oinq/oinq_trustpilot.svg';
import { useModalContext } from '../../templates/ModalProvider/ModalProvider';
import Txt from '../../atoms/Txt/Txt';
import { alertMessageTimeout as messageTimeout } from '../../molecules/AlertMessage/alertMessageTimeout';
import useTrustpilotReview from '../../../hooks/useTrustpilotReview';

export interface Props {
  defaultModalProps?: any;
}

export const useWasShownReviewPrompt = () => {
  const wasShownReviewPrompt = localStorage.getItem('reviewDialog');
  return wasShownReviewPrompt;
};

const ReviewDialog: React.FC<Props> = ({ defaultModalProps }) => {
  const trustpilotReview = useTrustpilotReview();
  const { hideModal, modalProps } = useModalContext();
  const thisModalProps = defaultModalProps || modalProps;
  const alert = useAlert();
  const reviewCloseMessage =
    'Thanks! you should receive an email from Trustpilot asking for a review shortly';

  React.useEffect(() => {
    const now = new Date();
    localStorage.setItem('reviewDialog', now.toString());
  }, []);

  function handleClickConfirm() {
    trustpilotReview();

    alert.show(reviewCloseMessage, {
      type: 'success',
      timeout: messageTimeout(reviewCloseMessage),
    });
    hideModal();
    thisModalProps.onClose();
  }

  function handleCloseReviewDialog() {
    hideModal();
    thisModalProps.onClose();
  }

  return (
    <Overlay onClose={handleCloseReviewDialog}>
      <div className={classes.root}>
        <Txt component="h2">Want to share your experience with us and others?</Txt>
        <div className={classes.oinqWrapper}>
          <Oinq className={classes.oinq} />
        </div>
        <Txt component="p">
          Click &apos;Sure&apos; to receive an email from Trustpilot where you can leave us a
          review!
        </Txt>
        <div className={classes.buttons}>
          <Button className={classes.button} onClick={handleCloseReviewDialog}>
            <Txt component="span">No thanks</Txt>
          </Button>
          <Button className={classes.button} buttonType="primary" onClick={handleClickConfirm}>
            <Txt component="span">Sure</Txt>
          </Button>
        </div>
      </div>
    </Overlay>
  );
};

export default ReviewDialog;
